import { render, staticRenderFns } from "./CdkFavoriteIcon.vue?vue&type=template&id=225f8d30&scoped=true&"
import script from "./CdkFavoriteIcon.vue?vue&type=script&lang=ts&"
export * from "./CdkFavoriteIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CdkFavoriteIcon.vue?vue&type=style&index=0&id=225f8d30&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225f8d30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VLayout,VTooltip})
